import { render } from "./PeoplePeterson.vue?vue&type=template&id=169b4b3f"
import script from "./PeoplePeterson.vue?vue&type=script&lang=js"
export * from "./PeoplePeterson.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__